/* eslint-disable react/no-unused-prop-types */
/* eslint-disable max-len */
/* eslint-disable react/no-danger */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDesignSystem } from './utils/design-system/useDesignSystem';
import { contrast } from './styles/colors';
import Images from './utils/Images';

const Styles = (props) => {
  const {
    customCSS,
    customFont,
    primaryColor,
    menuTextColor,
    bodyFont,
    bgImage,
    background,
    backgroundColor,
    customDocument,
  } = props;

  // const parentPrefix = scope ? `.${scope} ` : '';
  const primaryContrast = contrast(primaryColor, '#ffffff');
  const contrastIsEnough = primaryContrast >= 2;
  const contrastColor = contrastIsEnough ? '#ffffff' : '#363636';
  const primaryContrastColor = contrastIsEnough ? primaryColor : contrastColor;

  // Resolved here so App.scss never needs a var() fallback
  const menuText = menuTextColor || contrastColor;
  const menuTextInvert = menuTextColor || primaryContrastColor;
  const menuBorderInvert = menuTextColor || primaryColor;

  const { generateGlobalStyle } = useDesignSystem(customDocument);

  const globalStyle = useMemo(
    () =>
      generateGlobalStyle({
        additionalVariables: {
          color: {
            primary: primaryColor,
            'primary-contrast': primaryContrastColor,
            background: backgroundColor,
            contrast: contrastColor,
            'menu-text': menuText,
            'menu-text-invert': menuTextInvert,
            'menu-border-invert': menuBorderInvert,
          },
          background: {
            ...background,
            image: bgImage ? `url(${Images.maxWidth(bgImage, 1920)})` : '',
          },
        },
        customFont,
        bodyFont,
      }),
    [
      generateGlobalStyle,
      primaryColor,
      primaryContrastColor,
      menuText,
      menuTextInvert,
      menuBorderInvert,
      backgroundColor,
      contrastColor,
      background,
      bgImage,
      customFont,
      bodyFont,
    ],
  );

  return (
    <style
      dangerouslySetInnerHTML={{
        __html: `
        ${globalStyle}
          ${customCSS}
          `,
      }}
    />
  );
};

const fontProps = PropTypes.shape({
  category: PropTypes.string,
  kind: PropTypes.string,
  family: PropTypes.string,
});

Styles.defaultProps = {
  customCSS: '',
  primaryColor: undefined,
  menuTextColor: undefined,
  scope: undefined,
  bodyFont: undefined,
  customFont: undefined,
};

Styles.propTypes = {
  customCSS: PropTypes.string,
  primaryColor: PropTypes.string,
  menuTextColor: PropTypes.string,
  scope: PropTypes.string,
  bodyFont: fontProps,
  customFont: fontProps,
  customDocument: PropTypes.any,
};

export default Styles;
